export default {
  STRIPE_KEY: 'pk_live_eCffHUo8C98ex1XAZKUIG5sk', // pk_live_eCffHUo8C98ex1XAZKUIG5sk  pk_test_LsZ8a24e5UDFhG9CXud6hz9y
  COST: [{
    cost: 0
  }, {
    cost: 190 * 100
  }],
  CURRENCY: 'GBP'
};